var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex items-center" }, [
    _c("input", {
      staticClass: "react-switch-checkbox",
      attrs: { id: "react-switch-new", type: "checkbox" },
      domProps: { checked: _vm.isSwithActive },
      on: { input: _vm.handleToggle },
    }),
    _c(
      "label",
      {
        staticClass: "react-switch-label label_wrapper",
        style: {
          background: _vm.isSwithActive ? _vm.onColor : _vm.offColor,
          width: _vm.width,
          height: _vm.height,
        },
        attrs: { for: "react-switch-new" },
      },
      [
        _c("span", {
          staticClass: "react-switch-button",
          style: _vm.ballStyles,
        }),
        _vm.showIcons
          ? [
              _vm._t("rightIcon", function () {
                return [
                  !_vm.isSwithActive
                    ? _c("CrossIcon", {
                        staticClass: "switch_icon_class switch_cross_icon",
                      })
                    : _vm._e(),
                ]
              }),
              _vm._t("leftIcon", function () {
                return [
                  _vm.isSwithActive
                    ? _c("TickIcon", {
                        staticClass: "switch_icon_class switch_tick_icon",
                      })
                    : _vm._e(),
                ]
              }),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }